import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {ListaProyectosComponent} from "./components/lista-proyectos/lista-proyectos.component";
import {NuevoProyectoComponent} from "./components/nuevo-proyecto/nuevo-proyecto.component";
import {
    GeneralidadesNuevoProyectoComponent
} from "./components/nuevo-proyecto/components/generalidades-nuevo-proyecto/generalidades-nuevo-proyecto.component";
import {VerProyectoComponent} from "./components/ver-proyecto/ver-proyecto.component";

export const routes: Routes = [
    {
        path: '', component: ListaProyectosComponent,
    },
    {
        path: 'nuevo_proyecto',
        component: NuevoProyectoComponent,
        children: [
            {
                path: 'generalidades',
                component: GeneralidadesNuevoProyectoComponent
            }
        ]
    },
    {
        path: 'ver_proyecto/:idProyecto',
        component: VerProyectoComponent
    }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProyectosRoutingModule {
}
